















































import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Media, Lot, Auction } from '@/api';
import { apiBase, apiNamespace } from '@/config';
import Cookies from 'js-cookie';

// @ts-ignore
import VueDropzone from 'vue2-dropzone';

@Component({
  components: { VueDropzone },
})
export default class extends Vue {
  @Prop({ required: true }) readonly auctionId: string;

  importResponse: { errors: any; updated: [] } | null = null;

  get isErrors() {
    if (!this.importResponse) {
      return;
    }
    return Object.keys(this.importResponse.errors).length > 0;
  }

  get dropzoneOptions() {
    return {
      url: `${apiBase}${apiNamespace}/auctions/${this.auctionId}/update_lots/`,
      autoProcessQueue: false,
      addRemoveLinks: true,
      maxFilesize: 20,
      maxFiles: 1,
      paramName: 'data',
      method: 'patch',
      params: {
        add_missing: true,
      },
      headers: {
        'X-CSRFTOKEN': Cookies.get('csrftoken'),
        // Authorization: Media.generateAuthHeader(
        //   localStorage.getItem('jwt') || '',
        // ),
        'Cache-Control': undefined,
        Accept: 'application/vnd.api+json',
      },
      dictDefaultMessage: 'Click or drag a file here to upload',
    };
  }

  sendingEvent(file: any, xhr: any, formData: any) {
    // console.log('file sending');
  }

  fileAdded() {
    // console.log('file added');
  }

  fileUploaded(file: any) {
    // console.log('file uploaded', file);
  }

  importComplete(response: any) {
    const importResponse = JSON.parse(response.xhr.response);
    this.importResponse = importResponse.data;
  }

  processUpload() {
    // @ts-ignore
    this.$refs.importLotsDropzone.processQueue();
  }

  close() {
    this.$emit('close-import');
  }
}
